import { AxiosInstance } from "axios"
import { ServiceResponse } from "../../../core/api/apiTypes"

export async function confirmBooking(
    request: {
        orderUid: string
    },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{ success: boolean }>> {
    const { data } = await axios.post("/authenticate/confirmBooking", request, { signal })

    return data
}
